import { render, staticRenderFns } from "./CMSHealthInformation.vue?vue&type=template&id=44892ef3&scoped=true"
import script from "./CMSHealthInformation.vue?vue&type=script&lang=js"
export * from "./CMSHealthInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44892ef3",
  null
  
)

export default component.exports